import { reportsApi } from 'Api/axios/reports-api';
import useEmployeesReportApi from 'Hooks/useEmployeesReportApi';
import useTranslation from 'Hooks/useTranslation';
import { useEffect, useState } from 'react';
import type { EmployeeReportFilterI } from 'types';
import { downloadFile } from 'Utils/file-utils';

const useEmployeeReportPage = () => {
  const { t2 } = useTranslation('employees_reports');
  const [currentFilters, setCurrentFilters] = useState<EmployeeReportFilterI>({});
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(15);

  const {
    data: employeesReportData,
    pagination,
    loading: employeesReportLoading,
    error: employeesReportError,
    fetchEmployeesReport,
  } = useEmployeesReportApi({ init: false });

  useEffect(() => {
    fetchEmployeesReport({ ...currentFilters, page, pageSize });
  }, [page, pageSize, currentFilters]);

  const handleSearch = (filters: EmployeeReportFilterI) => {
    setPage(1);
    setCurrentFilters(filters);
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (newPageSize: number) => {
    setPage(1);
    setPageSize(newPageSize);
  };

  const handleExport = async () => {
    const response = await reportsApi.exportEmployees(currentFilters);
    if (response.data) {
      downloadFile(response.data, `empleados_reporte.xlsx`);
    }
  };

  return {
    employeesReportData,
    employeesReportLoading,
    employeesReportError,
    pagination,
    t2,
    handleSearch,
    handlePageChange,
    handleRowsPerPageChange,
    handleExport,
  };
};

export default useEmployeeReportPage;
